module.exports = __webpack_public_path__ + "static/media/reddit.4c55d0f2.svg";